import { Action, createAction, createReducer, on, props, State } from '@ngrx/store';
import difference from 'lodash/difference';
import union from 'lodash/union';
import { ACLCanStore, ACLStore } from './acl.type';

export const selectACL = (state: { acl: ACLStore }) => state.acl;

export const setACL = createAction('[ACL] Set Permission', props<{ acl: ACLCanStore }>());
export const attachACL = createAction('[ACL] Attach Permission', props<{ acl: ACLCanStore }>());
export const removeACL = createAction('[ACL] Remove Permission', props<{ acl: ACLCanStore }>());
export const setBigGroup = createAction('[ACL] Set BigGroupList', props<{ bigGroupList: string[] }>());

export function aclReducer(pState: ACLStore | undefined, action: Action) {
  return createReducer(
    { permission: [] } as ACLStore,
    on(setACL, (state, { acl }) => ({ permission: formatCanStore(acl) })),
    on(attachACL, (state, { acl }) => {
      state.permission = union(state.permission, formatCanStore(acl));
      return state;
    }),
    on(removeACL, (state, { acl }) => {
      state.permission = difference(state.permission, formatCanStore(acl));
      return state;
    })
  )(pState, action);
}

export function bigGroupListReducer(pState: string[] | undefined, action: Action) {
  return createReducer(
    {},
    on(setBigGroup, (state, bigGroupList) => bigGroupList)
  )(pState, action);
}

function formatCanStore(acl: ACLCanStore): string[] {
  return Array.isArray(acl) ? acl : typeof acl === 'object' ? acl.permission : [acl];
}
